export default "__VITE_ASSET__tPQiclD7__"